(function () {
    'use strict';
    angular.module('Directives').directive('bbaModulesDashboardAccessPermissions', bbaModulesDashboardAccessPermissions);
    bbaModulesDashboardAccessPermissions.$inject = [
        'FleetService'
    ];

    function bbaModulesDashboardAccessPermissions(FleetService) {
        return {
            restrict: 'E',
            replace: true,
            require: '^form',
            templateUrl: '/templates/directives/components/administration/bba-modules-dashboard-access-permissions.html',
            scope: {
                ngModel: '='
            },
            link: bbaModulesDashboardAccessPermissionsLink
        }

        function bbaModulesDashboardAccessPermissionsLink($scope) {
            const congiurationPermissionNames = [
                'Accounts',
                'Office',
                'Marketplace',
                'Historical Invoice',
                'Permissions',
                'Third Party Accounting Apps'
            ];
            

            $scope.permissionsGroups = [];
            $scope.isAllSelected = false;

            $scope.selectAll = selectAll;
            $scope.selectedAreas = selectedAreas;
            $scope.listArea = []
            init();

            function init() {
                getUsersAreas();
                setNgModelWatcher();
                getAreasAndRoute();
            }

            function setNgModelWatcher() {
                groupPermissions();
                $scope.$watch('ngModel', (data) => {
                    if (!data) { return; }
                    setIsSelectedDefaultValue();
                }, true);
            }

            function getAreasAndRoute(){
                FleetService.Areas.getAll(
                    success=>{
                        const list =[]
                        success.content.forEach(item=>{
                            list.push({
                                areaId:item.id,
                                areaName:item.areaId,
                                active:true
                            })
                        })
                        $scope.areaList = list;
                    },error=>{
                        console.log(error);
                    },{size:50})
            }

            function selectedAreas(){
                if(!$scope.areaList){ return}
                angular.forEach($scope.ngModel,(item)=>{
                    if(item.id===18){
                        $scope.listArea = $scope.areaList.filter(
                            data=> !item.selectedAreas.find(areaId=>areaId.areaId ===data.areaId)
                        );
                    }
                })
            }

            function groupPermissions() {
                getReportingShipmentsPermissions();
                getCarrierManagementPermissions();
                getFleetManagementPermissions();
                getAdditionalPermissions();
            }

            function setIsSelectedDefaultValue() {
                $scope.isAllSelected = checkIfAllPermissionIsActive();
            }

            function checkIfAllPermissionIsActive() {
                const inActivePermissions = $scope.ngModel.filter(permission => !permission.active);
                return inActivePermissions.length < 1;
            }

            function getReportingShipmentsPermissions() {
                
            }

            function getCarrierManagementPermissions() {
                
            }

            function getUsersAreas(){
                angular.forEach($scope.ngModel,(item)=>{
                    if(item.id === 18){
                       angular.forEach(item.selectedAreas,data=>{
                            data.active = true
                       });
                    }
                })
            }

            function getFleetManagementPermissions() {
                const fotherModulePermissions = $scope.ngModel.filter(data => {
                    const configPermissions = congiurationPermissionNames.find(name => name === data.name)
                        if(!configPermissions && data.id !==38){
                            return data
                        }
                });
                $scope.permissionsGroups.push({
                    name: 'Other Module',
                    permissions: fotherModulePermissions
                })
            }

            function getAdditionalPermissions() {
                const configPermissions = $scope.ngModel.filter(data => congiurationPermissionNames.find(name => name === data.name));

                $scope.permissionsGroups.push({
                    name: 'Configuration Module',
                    permissions: configPermissions
                });
            }

            function selectAll(isSelectAll) {
                $scope.ngModel.forEach(data => {
                    data.active = isSelectAll;
                });
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/component/administration/bba-modules-dashboard-access-permissions.js